import { React, useState, useEffect } from "react";
import { Row, Col, CardBody, Card, Alert, Container } from "reactstrap";
import { } from "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "./login.css";
import { Redirect, useHistory } from "react-router-dom";
import httpService from "../../services/http.service";
import loginImg from "../../assets/loginleft.png";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../common/loader";
import ErrorMessage from "../common/errorMsg";
import SuccessMessage from "../common/successMsg";


let AdminLogin = (props) => {
  const history = useHistory();
  const [login, setLogin] = useState(true);
  const [loading, setLoading] = useState(false);
  const [rememberMe, setRememberMe] = useState(false);
  const [initcustomerId, setInitCustomerId] = useState();
  const [initpassword, setInitPassword] = useState();
  const [data, setData] = useState({
    customerId: "",
    password: "",
  });
  useEffect(() => {
    if (!props.verifyToken) {
      httpService.getByBoj('logout', { userId: localStorage.getItem("UserId") })
      localStorage.clear();
      setLogin(!props.verifyToken)
    }
    const customerID = localStorage.getItem("customerId");
    const type = localStorage.getItem("CloudUserType");
    if (customerID === 'Admin' || type === "admin") {
      history.push("/admindashboard");
    } else if ((localStorage.getItem("UserId")) && type === "clouduser") {
      history.push("/clouddashboard");
    } else if ((localStorage.getItem("UserId")) && type === "property_manager") {
      history.push("/property-manager")
    }
    else {
      // history.push("/adminlogin");
      // window.location.reload();
    }
  }, []);

  useEffect(() => {
    getCookies();
  }, [])

  const getCookies = () => {
    let customerId = getCookie("AdmincustomerId");
    let password = getCookie("Adminpassword");
    if (customerId && password) {
      let user = {
        customerId: customerId,
        password: password,
      }
      setData(user);
      setRememberMe(true);
      setInitCustomerId(customerId)
      setInitPassword(password)
    };

  }
  const getCookie = (cname) => {
    let name = cname + "=";
    let ca = document.cookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
    return "";
  }

  function clearListCookies() {
    var cookies = document.cookie.split(";");
    for (var i = 0; i < cookies.length; i++) {
      var spcook = cookies[i].split("=");
      deleteCookie(spcook[0]);
    }
    getCookies();
    // window.location = ""; // TO REFRESH THE PAGE
  }

  function deleteCookie(cookiename) {
    var d = new Date();
    d.setDate(d.getDate() - 1);
    var expires = ";expires=" + d;
    var name = cookiename;
    var value = "";
    document.cookie = name + "=" + value + expires + ";";
  }

  let handleValidSubmit = async (event, values) => {
    event.preventDefault();
    //setLogin(false);
  };

  const onInputChange = (e) => {
    setData({ ...data, [e.target.name]: e.target.value });
  };

  const setCookies = () => {
    if (rememberMe) {
      let time = new Date();
      time.setTime(time.getTime() + 24 * 60 * 60 * 1000 * 30);
      let g = `AdmincustomerId=${data.customerId};expires=${time.toUTCString()};`
      let h = `Adminpassword=${data.password};expires=${time.toUTCString()};`
      document.cookie = g;
      document.cookie = h;
      setRememberMe(true);
    } else {
      clearListCookies();
      getCookies();
      setRememberMe(false);
    }
  }

  const loginSave = async () => {
    showLoader();
    if (data.customerId == '' || data.password == '') {
      hideLoader();
      ErrorMessage("Please fill the all Admin details")
      return;
    }
    let res = await httpService
      .CreateUpdate("getloginapi", data)
      .catch((err) => {
        if (err) {
          hideLoader();
          ErrorMessage("Something went wrong")
          return;
        }
      });
    if (res) {
      if (rememberMe) { setCookies() }
      else {
        let c = `AdmincustomerId=;expires=0;`
        let d = `Adminpassword=;expires=0;`
        document.cookie = c;
        document.cookie = d;
      }
      if (res.data.message === "login successfull") {
        hideLoader();
        SuccessMessage("Login Successfully ")
        localStorage.setItem("isSession", true);
        localStorage.setItem("customerId", data.customerId);
        localStorage.setItem("UserId", res.data.data._id);
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("CloudUserType", "admin");
        props.setVerifyToken(true)
        if (res.data.dataFirst === true) {
          localStorage.setItem("dataFirst", res.data.dataFirst);
        } else {
          localStorage.setItem("dataFirst", false);
        }
        localStorage.setItem("CloudUserType", res.data.data.type.toLowerCase());
        if (res.data.dataFirst === true) {
          history.push({
            pathname: "/admindashboard/changepassword",
            state: { detail: res.data.data },
          });
        }
        // if (data.customerId === 'Admin' || (res.data.data.type && res.data.data.type.toLowerCase() === "admin")) {
        if (data.customerId === 'Admin' || (res.data.data.type && res.data.data.type.toLowerCase() === "admin")) {
          if (res.data.dataFirst === true) {
            history.push({
              pathname: "/admindashboard/changepassword",
              // search: "?query=abc",
              state: { detail: res.data.data },
            });
          } else {
            history.push({
              pathname: "/admindashboard",
              // search: "?query=abc",
              state: { detail: res.data.data },
            });
          }
          // cloud user for the clouddashboard
        } else if ((res.data.data.type && res.data.data.type.toLowerCase() === "clouduser")) {
          history.push({
            pathname: "/clouddashboard",
            // search: "?query=abc",
            state: { detail: res.data.data },
          });
        } else {
          history.push({
            pathname: "/dashboard",
            // search: "?query=abc",
            state: { detail: res.data.data },
          });
        }
      } else {
        ErrorMessage(res.data.message)
        localStorage.setItem("isSession", false);
        history.push("/adminlogin");
      }
    }
    hideLoader();
  };
  const showLoader = () => {
    setLoading(true);
  }
  const hideLoader = () => {
    setLoading(false);

  }
  return (
    <div>
      {loading ? <Loader /> : null}
      {login ? (
        <div>
          <div className="home-btn d-none d-sm-block">
            <i className="bx bx-home h2"></i>
          </div>
          <div className="account-pages">
            <Container>
              <Row className="justify-content-center">
                <Col md={12} lg={11} xl={8}>
                  <Card className="overflow-hidden login-wrapper">
                    <CardBody className="row">
                      <div className="col-6 p-0">
                        <div className="login-img">
                          <img src={loginImg} alt="LoginImage" />
                        </div>
                      </div>
                      <div className="col-6 p-0">
                        <div className="login-right">
                          <div className="login-txthead">Admin Login</div>
                          <p className="signText">
                            Sign in to continue to RSD.
                          </p>
                          <div className="">
                            <form
                              className="form-horizontal login-form"
                              onSubmit={handleValidSubmit}
                            >
                              <div className="form-group">
                                <span className="input-icon">
                                  <i className="fa fa-user"></i>
                                </span>
                                <input
                                  name="customerId"
                                  value={data.customerId}
                                  className="form-control formInput"
                                  placeholder="Admin ID"
                                  type="text"
                                  onChange={(e) => {
                                    const regex = /^[a-zA-Z0-9_ ]*$/
                                    const { value } = e.target

                                    if (regex.test(value)) {
                                      onInputChange(e)
                                    }
                                    
                                    { initcustomerId === e.target.value ? setRememberMe(true) : setRememberMe(false) }

                                  }}
                                // validate={{
                                //   required: {
                                //     value: true,
                                //     errorMessage: "Required",
                                //   },
                                // }}
                                />
                              </div>

                              <div className="form-group">
                                <span className="input-icon">
                                  <i className="fa fa-lock"></i>
                                </span>
                                <input
                                  name="password"
                                  value={data.password}
                                  type="password"
                                  className="form-control formInput"
                                  onChange={(e) => {
                                    onInputChange(e)
                                    { initpassword === e.target.value ? setRememberMe(true) : setRememberMe(false) }
                                  }}
                                  placeholder="Password"
                                />
                              </div>
                              <div className="custom-control custom-checkbox ml-0">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  id="customControlInline"
                                  checked={rememberMe}
                                  onChange={(e) => {
                                    setRememberMe(!rememberMe)
                                  }}
                                />
                                <label className="custom-control-label pt-1" htmlFor="customControlInline"
                                >
                                  {" "}
                                  Remember me
                                </label>
                              </div>
                              <div className="mt-2 text-center">
                                <button
                                  className="btn btn-primary"
                                  type="submit"
                                  onClick={() => loginSave()}
                                >
                                  Log In
                                </button>
                              </div>
                            </form>
                          </div>
                        </div>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      ) : (
        <Redirect to="/dashboard" />
      )}
    </div>
  );
};

export default AdminLogin;
